export default "__VITE_ASSET__DK_6gqQd__"